












import CommonBase from "../CommonBase";
import {Component, Prop} from "vue-property-decorator";
import {DateTime, TerminalLocationRegcode} from "../../modules/models";

@Component
export default class RegcodeDisplay extends CommonBase{
    @Prop()
    regcode?: TerminalLocationRegcode;

    get regcodeFormatted() {
        if(this.regcode) {
            return this.regcode.regcodeFormatted;
        } else {
            return "";
        }
    }
}
